import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

import {
  bomConfigVersionId,
  type BomConfigVersionId,
} from './BomConfigVersion.js'

/** Identifier type for public.bom_routing_ */
export type BomRoutingId = string & { __brand: 'BomRoutingId' }

/** Represents the table public.bom_routing_ */
export default interface BomRoutingTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<BomRoutingId, BomRoutingId | undefined, BomRoutingId>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  createdBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  updatedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  updatedBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  deletedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  deletedBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.uuid */
  versionId: ColumnType<
    BomConfigVersionId,
    BomConfigVersionId,
    BomConfigVersionId
  >

  /** Database type: pg_catalog.text */
  key: ColumnType<string, string, string>

  /** Database type: pg_catalog.text */
  displayName: ColumnType<string, string, string>

  /** Database type: pg_catalog.bool */
  isActive: ColumnType<boolean | null, boolean | null, boolean | null>
}

export type BomRouting = Selectable<BomRoutingTable>

export type BomRoutingInitializer = Insertable<BomRoutingTable>

export type BomRoutingMutator = Updateable<BomRoutingTable>

export const bomRoutingId = z.string() as unknown as z.Schema<BomRoutingId>

export const bomRouting = z.object({
  id: bomRoutingId,
  createdAt: z.coerce.date().nullable().optional(),
  createdBy: z.string().nullable().optional(),
  updatedAt: z.coerce.date().nullable().optional(),
  updatedBy: z.string().nullable().optional(),
  deletedAt: z.coerce.date().nullable().optional(),
  deletedBy: z.string().nullable().optional(),
  versionId: bomConfigVersionId,
  key: z.string(),
  displayName: z.string(),
  isActive: z.boolean().nullable().optional(),
}) as unknown as z.Schema<BomRouting>

export const bomRoutingInitializer = z.object({
  id: bomRoutingId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: z.string().optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: z.string().optional().nullable(),
  versionId: bomConfigVersionId,
  key: z.string(),
  displayName: z.string(),
  isActive: z.boolean().optional().nullable(),
}) as unknown as z.Schema<BomRoutingInitializer>

export const bomRoutingMutator = z.object({
  id: bomRoutingId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: z.string().optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: z.string().optional().nullable(),
  versionId: bomConfigVersionId.optional(),
  key: z.string().optional(),
  displayName: z.string().optional(),
  isActive: z.boolean().optional().nullable(),
}) as unknown as z.Schema<BomRoutingMutator>
